<nz-spin [nzSize]="'large'" [nzSpinning]="submitted">
  <form nz-form [nzLayout]="'vertical'" (ngSubmit)="register()" [formGroup]="registerForm" aria-labelledby="sub-title">
    <div class="auth-wrapper">
      <p class="sub-title">Create your Carvry account</p>
      <nz-form-item>
        <nz-form-label nzRequired nzFor="full-name">Full name</nz-form-label>
        <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Your name is required!">
          <input nz-input autocomplete="on" formControlName="fullName" id="full-name" nzSize="large" autofocus
                 [attr.aria-invalid]="f.fullName.invalid && f.fullName.touched ? true : null">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="email">Email</nz-form-label>
        <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Email must be a valid email address!">
          <input nz-input autocomplete="on" formControlName="email" id="email" nzSize="large" autofocus
                 [attr.aria-invalid]="f.email.invalid && f.email.touched ? true : null">
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="password-form-item">
        <nz-form-label nzFor="password" nzRequired>Password</nz-form-label>
        <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Password must be at least 6 characters!">
          <nz-input-group [nzSuffix]="suffixTemplate" nzSize="large">
            <input nz-input autocomplete="current-password" formControlName="password" type="password" id="password"
                   placeholder="Password" [type]="passwordVisible ? 'text' : 'password'" required
                   [attr.aria-invalid]="f.password.invalid && f.password.touched ? true : null">
          </nz-input-group>
          <ng-template #suffixTemplate>
            <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
               (click)="passwordVisible = !passwordVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="password-form-item">
        <nz-form-label nzFor="confirm-password" nzRequired>Confirm Password</nz-form-label>
        <nz-form-control [nzXs]="24" nzSpan="18" nzErrorTip="Passwords do not match!">
          <nz-input-group [nzSuffix]="suffixTemplate" nzSize="large">
            <input nz-input formControlName="confirmPassword" type="password" id="confirm-password" nzSize="large"
                   placeholder="Confirm Password" [type]="passwordVisible ? 'text' : 'password'" required
                   [attr.aria-invalid]="f.confirmPassword.invalid && f.confirmPassword.touched ? true : null">
          </nz-input-group>
          <ng-template #suffixTemplate>
            <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
               (click)="passwordVisible = !passwordVisible"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <div nz-row>
        <div nz-col nzSpan="22" nzOffset="1">
          <p class="text-center">
            By creating an account, you agree to our
            <a href="https://www.carvry.com/terms.html" target="_blank" id="register-terms"><strong>Terms &
              Conditions</strong></a>
            and acknowledge our
            <a href="https://www.carvry.com/privacy.html" target="_blank" id="register-policy"><strong>Privacy
              Policy</strong></a>.
          </p>
        </div>
      </div>

      <div nz-row nzJustify="center" nzAlign="middle" class="register-button">
        <div nz-col nzXs="24" nzSm="16" nzMd="14" nzLg="12" nzXl="12" nzXXl="12">
          <button nz-button nzType="primary" nzSize="large" nzBlock [nzLoading]="submitted" type="submit"
                  id="create-account-button" aria-label="Create Account"
                  [disabled]="submitted || registerForm.invalid" [class.btn-pulse]="submitted">
            Create an account
          </button>
        </div>
      </div>
      <section class="another-action" aria-label="Sign in">
        Already have an account? <a class="text-link" [routerLink]="['/login']">Sign in</a>
      </section>
      <nz-divider nzText="OR" class="method-divider"></nz-divider>
      <div nz-row nzAlign="middle" nzJustify="center">
        <div nz-col nzXs="24" nzSm="20" nzMd="18" nzLg="18" nzXl="16" nzXXl="16">
          <button nz-button nzType="primary" nzSize="large" nzBlock class="fcbk-button" (click)="loginWithFacebook()">
            <fa-icon class="fcbk-icon" [icon]="faFacebook"></fa-icon>
            <span class="text">Continue with Facebook</span>
            <span class="end"></span>
          </button>
        </div>
      </div>
      <div nz-row nzAlign="middle" nzJustify="center">
        <div nz-col nzXs="24" nzSm="20" nzMd="18" nzLg="18" nzXl="16" nzXXl="16">
          <button nz-button nzType="default" nzSize="large" nzBlock class="google-button" (click)="loginWithGoogle()">
            <span class="icon-wrapper">
              <svg viewBox="0 0 18 18" role="presentation" aria-hidden="true" focusable="false" class="icon">
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
                    fill="#EA4335"></path>
                  <path
                    d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
                    fill="#4285F4"></path>
                  <path
                    d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
                    fill="#FBBC05"></path>
                  <path
                    d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
                    fill="#34A853"></path>
                  <path d="M0 0h18v18H0V0z"></path>
                </g>
              </svg>
            </span>
            <span class="text">Continue with Google</span>
            <span class="end"></span>
          </button>
        </div>
      </div>
    </div>
  </form>
</nz-spin>
